// extracted by mini-css-extract-plugin
export default {"fullWidth":"in-z","image":"jn-z","lazyLoadPicture":"kn-z","lazyLoadSpinner":"ln-z","lazyLoadSpin":"mn-z","lazyLoadImage":"nn-z","hasStyledAspectRatio":"on-z"};